import { CommonModule, Location } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PaginationComponent } from 'src/app/home/common/pagination/pagination.component';
import { WarehouseService } from 'src/app/home/services/warehouse.service';
import { MasterService } from 'src/app/home/services/master.service';
import { timestampFormat } from '../../../app/config/moment';

@Component({
  selector: 'app-transit-summary',
  standalone: true,
  imports: [CommonModule, FormsModule, PaginationComponent],
  templateUrl: './transit-summary.component.html',
  styleUrls: ['./transit-summary.component.scss', '../../app.component.scss']
}) 
export class TransitSummaryComponent {

  @ViewChild(PaginationComponent) paginationView: PaginationComponent;

  public timestampFormat = timestampFormat;
  public Math = Math; // Make Math available in template
  
  public warehouseId = "4";
  public warehouses: any = [];
  public warehouseDetails: any;

  public transitStocks: any = [];
  public searchResults: any = [];
  public isTransitStocks: boolean = false;

  public totalPages: number = 0;
  public currentPage: number = 1;
  public pageSize: number = 14; // Default page size
  
  public totalStocks: number = 0;
  public totalRecords: number = 0; // Total records for display

  public searchInput: string = "";
  public encodedSearchInput: string = "";


  public isSearch = false;
  public isFilter = false;
  public isFilterResult = true;

  public selectedStatus = [];
  
  public shippedAtSortValue:string = "";
  public deliveredAtSortValue:string = "";
  public orderBy:string = "asc";

  constructor(public warehouseService: WarehouseService, public masterService: MasterService, public location: Location, public route: ActivatedRoute, public router: Router){

  }

  ngOnInit(): void {
    this.getTransitStocks();
  }

  getWarehouses(){
    this.masterService.getIndexGet('/warehouses').subscribe((res) => {
      if (res.data && Array.isArray(res.data)) {
        this.warehouses = res.data;
        // Set default warehouse to first one if available
        if (this.warehouses.length > 0) {
          this.warehouseId = this.warehouses[0].id.toString();
          this.getTransitStocks();
        }
      }
    });
  }

  getTransitStocks(page: string = "", search: string = "", shippedAt: string = "", deliveredAt: string = "", status: Array<string> = []){
    this.warehouseService.getTransitStocks(this.warehouseId, page, search, shippedAt, deliveredAt, status).subscribe((res)=>{
      if (res.data) {
        if (res.data.data.length !== 0) {
          this.totalStocks = res.data.total;
          this.totalRecords = res.data.total; // Set total records for display
          this.totalPages = res.data.last_page;
          this.transitStocks = res.data.data;

          if (this.isSearch) {
            this.searchResults = res.data.data;
            this.isFilterResult = true;
          } else if (this.isFilter) {
            this.isFilterResult = true;
          } else {
            this.isTransitStocks = true;
          }
        }else{
          this.totalStocks = 0;
          this.totalRecords = 0; // Reset total records
          this.totalPages = 0;
          if (this.isSearch) {
            this.searchResults = [];
            this.isFilterResult = false;
          } else if (this.isFilter) {
            this.isFilterResult = false;
          } else {
            this.isTransitStocks = false;
          }
        }
      }
    })
  }

  onSearchSubmit(){
    if (this.searchInput !== "") {
      this.isSearch = true;
      if (this.isFilter) { 
        this.shippedAtSortValue = "";
        this.isFilter = false;
        this.isFilterResult = true;
      }
      this.encodedSearchInput = encodeURIComponent(this.searchInput);
      if (this.currentPage > 1) {
        this.currentPage = 1;
        this.paginationView.onCurrentPageChange(this.currentPage);
      }
      this.getTransitStocks("", this.encodedSearchInput);
    }
  }

  shippedAtSort(){
    this.isFilter = true;

    if (this.shippedAtSortValue === "asc") {
      this.shippedAtSortValue = "desc";
    }else{
      this.shippedAtSortValue = this.orderBy;
    }   

    this.onFilterChange();
  }

  deliveredAtSort(){
    this.isFilter = true;

    if (this.deliveredAtSortValue === "asc") {
      this.deliveredAtSortValue = "desc";
    }else{
      this.deliveredAtSortValue = this.orderBy;
    }

    this.onFilterChange();   
  }

  openStatusPopup(event){
    document.getElementById("status-popup").classList.toggle("active");
    event.stopPropagation()
    this.closePopupOutside("status-popup");
  }

  onStatusFilterChange(event){
    if (event.target.checked) {
      this.selectedStatus.push(event.target.value);
    }else{
      this.selectedStatus = this.selectedStatus.filter((element)=>{
        return element !== event.target.value;
      });
    }

    this.isFilter = true;

    this.onFilterChange();
  }

  reset(event: Event){
    event.preventDefault();
    if (this.isSearch || this.isFilter) {
      this.encodedSearchInput = "";
      this.searchInput = "";
      this.shippedAtSortValue = "";
      this.deliveredAtSortValue = "";
      this.selectedStatus = [];
      this.isSearch = false;
      this.isFilter = false;
      this.isFilterResult = true;
      this.searchResults = [];
      if (this.currentPage > 1) {
        this.currentPage = 1;
        this.paginationView.onCurrentPageChange(this.currentPage);
      }
      this.getTransitStocks("");
    }
  }

  onFilterChange(){
    if (this.currentPage > 1) {
      this.currentPage = 1;
      this.paginationView.onCurrentPageChange(this.currentPage);
    }
    
    this.getTransitStocks("", this.encodedSearchInput, this.shippedAtSortValue, this.deliveredAtSortValue, this.selectedStatus);
  }

  getQueryPage($event: number){
    this.currentPage = $event;    
    this.getTransitStocks(`${this.currentPage}`, this.encodedSearchInput, this.shippedAtSortValue, this.deliveredAtSortValue, this.selectedStatus);
  }

  goBack(){
    this.location.back();
  }

  navigateToDetailPage(shipmentId: string){
    this.router.navigate(['/transit/summary/' + shipmentId]);
  }

  closePopupOutside(popupId: string){
    let popupDiv = document.getElementById(popupId);

    document.addEventListener('click', function(event: any) {
      if (
        popupDiv.className.includes("active") &&
        !popupDiv.contains(event.target)
      ) {
        popupDiv.classList.remove("active");
      }
    })
  }

}
